import { useState, useEffect } from 'react';
import { EXTRA_SMALL, SMALL, MEDIUM, LARGE } from '../../consts/responsive-breakpoints';

// Hook
export function useWindowSize() {
   const isClient = typeof window === 'object';

   function getSize() {
      return {
         width: isClient ? window.innerWidth : undefined,
         height: isClient ? window.innerHeight : undefined,
         isMobile: isClient ? window.innerWidth < LARGE : undefined,
         isExtraSmall: isClient ? window.innerWidth < EXTRA_SMALL : undefined,
         isSmall: isClient ? window.innerWidth >= EXTRA_SMALL && window.innerWidth < SMALL : undefined,
         isMedium: isClient ? window.innerWidth >= SMALL && window.innerWidth < MEDIUM : undefined,
         isLarge: isClient ? window.innerWidth >= MEDIUM && window.innerWidth < LARGE : undefined
      };
   }

   const [windowSize, setWindowSize] = useState(getSize);

   useEffect(() => {
      if (!isClient) {
         return false;
      }

      function handleResize() {
         setWindowSize(getSize());
      }

      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
   }, []); // Empty array ensures that effect is only run on mount and unmount

   return windowSize;
}
